var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosepassList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29279 15.7064C8.48031 15.8939 8.73462 15.9992 8.99979 15.9992C9.26495 15.9992 9.51926 15.8939 9.70679 15.7064L11.9998 13.4134L14.2928 15.7064C14.4814 15.8886 14.734 15.9894 14.9962 15.9871C15.2584 15.9848 15.5092 15.8797 15.6946 15.6942C15.88 15.5088 15.9852 15.258 15.9875 14.9958C15.9897 14.7336 15.8889 14.481 15.7068 14.2924L13.4138 11.9994L15.7068 9.70643C15.8889 9.51783 15.9897 9.26523 15.9875 9.00303C15.9852 8.74083 15.88 8.49002 15.6946 8.30461C15.5092 8.1192 15.2584 8.01403 14.9962 8.01176C14.734 8.00948 14.4814 8.11027 14.2928 8.29243L11.9998 10.5854L9.70679 8.29243C9.51818 8.11027 9.26558 8.00948 9.00339 8.01176C8.74119 8.01403 8.49038 8.1192 8.30497 8.30461C8.11956 8.49002 8.01439 8.74083 8.01211 9.00303C8.00983 9.26523 8.11063 9.51783 8.29279 9.70643L10.5858 11.9994L8.29279 14.2924C8.10532 14.48 8 14.7343 8 14.9994C8 15.2646 8.10532 15.5189 8.29279 15.7064Z",
    fill: "#C60F0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosepassList);
export default __webpack_public_path__ + "static/media/closepassList.16c401f324b0f97cff221e4f1a7b0942.svg";
export { ForwardRef as ReactComponent };